import { Typography } from "@mui/material";
import moment from "moment";
import { dateFormat, shortDate } from "../../misc/dates";

// show the day-count hint only for dates close enough that it helps
const nearDays = 30;

export function TaskDueDate(props: {
    dueDate: string | null;
    dueTime: string | null;
    completed: boolean;

    // small draws the date at caption size, for a list where the title leads
    small?: boolean;
}) {
    if (!props.dueDate) return null;

    const due = moment(props.dueDate, dateFormat);
    let label = shortDate(props.dueDate);
    if (props.dueTime) label += " " + moment(props.dueTime, "HH:mm").format("h:mma");

    const days = due.startOf("day").diff(moment().startOf("day"), "days");
    const overdue = !props.completed && days <= 0;

    let hint = "";
    if (days < 0) hint = "Overdue";
    else if (days === 0) hint = "today";
    else if (days <= nearDays) hint = days + " days";

    return (
        <Typography variant={props.small ? "caption" : "body2"} component="span" noWrap={props.small}
                    color={overdue ? "error.main" : props.small ? "text.secondary" : undefined}
                    sx={props.small ? { flexShrink: 0 } : undefined}>
            {label}
            {hint && <span style={{ opacity: 0.7 }}>{" (" + hint + ")"}</span>}
        </Typography>
    );
}
